import script from "./TaskPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskPreview.vue?vue&type=script&setup=true&lang=js"

import "./TaskPreview.vue?vue&type=style&index=0&id=b7faec8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7faec8c"]])

export default __exports__